"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'wxcxc',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      dialogCategory: false,
      category: [],
      total_auditstatus: {},
      total_optionstatus: {},
      list: [],
      listLoading: true,
      listQuery: {
        type: 1,
        page: 1,
        total: 10,
        wx_status: 1
      },
      new_template_version: 0
    };
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.state.user.agentInfo;
    },
    siteInfo: function siteInfo() {
      return this.$store.state.user.siteInfo;
    }
  },
  mounted: function mounted() {
    this.getConfigs();
    this.getList();
  },
  methods: {
    /**
     * 模板注解
     */
    renderHeader: function renderHeader(h, _ref) {
      var column = _ref.column,
        $index = _ref.$index;
      return [column.label, h('el-tooltip', {
        props: {
          content: '小程序版本过旧可能会导致出错噢,请尽快更新至最新版本',
          placement: 'top'
        }
      }, [h('span', {
        class: {
          'el-icon-question': true
        }
      })])];
    },
    /**
     * 获取列表
     */
    getConfigs: function getConfigs() {
      var _this = this;
      this.$get('WxOpen/getConfigs', {
        tag: 'wm010001'
      }).then(function (res) {
        _this.new_template_version = res;
      });
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this2 = this;
      var url = 'WxOpen/getWxList';
      var listQuery = Object.assign({}, this.listQuery, {
        page: this.listQuery.page - 1
      });
      this.$get(url, this.listQuery).then(function (res) {
        _this2.total_auditstatus = res.total_auditstatus;
        _this2.total_optionstatus = res.total_optionstatus;
        _this2.listLoading = false;
        _this2.list = res.list;
        _this2.listQuery.total = res.total;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    /**
     * 上传代码
     */
    uploadCode: function uploadCode(row) {
      var _this3 = this;
      var that = this;
      this.$alert('确定将代码到该小程序吗？', '上传代码', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == "confirm") {
            _this3.loadObj = _this3.$loading({
              lock: true,
              text: '正在提交~~~',
              spinner: 'el-icon-loading'
            });
            _this3.$post('WxOpen/uploadMiniCode', {
              wxmini_appid: row.app_id
            }).then(function (res) {
              row.mini_info.option_status = 2;
              _this3.$message({
                message: '上传成功,正在获取类目',
                type: 'success'
              });
              that.getMiniCategoryList(row, 2);
            }).catch(function (err) {
              _this3.loadObj.close();
            });
          }
        }
      });
    },
    /**
     * 获取小程序类目
     */
    getMiniCategoryList: function getMiniCategoryList(row) {
      var _this4 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var that = this,
        params = {};
      this.$post('WxOpen/getMiniCategoryList', {
        wxmini_appid: row.app_id
      }).then(function (res) {
        if (res[0]) {
          if (type == 1) {
            _this4.loadObj = _this4.$loading({
              lock: true,
              text: '正在提交~~~',
              spinner: 'el-icon-loading'
            });
          }
          _this4.$message({
            message: '获取类目成功',
            type: 'success'
          });
          params[0] = res[0];
          params[0]['address'] = 'pages/index/index';
          params[0]['title'] = _this4.config.project_name;
          params[0]['tag'] = 'pages';
          params = JSON.stringify(params);
          _this4.auditMiniCode(row, params);
        } else {
          _this4.$message({
            message: '获取类目为空',
            type: 'error'
          });
        }
      }).catch(function (err) {
        _this4.loadObj.close();
      });
    },
    /**
     * 提交代码审核
     */
    auditMiniCode: function auditMiniCode(row, params) {
      var _this5 = this;
      this.$post('WxOpen/auditMiniCode', {
        wxmini_appid: row.app_id,
        audit_items: params
      }).then(function (res) {
        _this5.loadObj.close();
        _this5.$message({
          message: '提交审核成功',
          type: 'success'
        });
        _this5.getList();
      }).catch(function (err) {
        _this5.loadObj.close();
      });
    },
    /**
     * 刷新审核状态
     */
    refreshAudit: function refreshAudit(row) {
      var _this6 = this;
      this.$post('WxOpen/refreshMiniCodeAuditResult', {
        wxmini_appid: row.app_id,
        audit_id: row.mini_info.audit_id
      }).then(function (res) {
        row.mini_info.audit_status = res.audit_status;
        if (res.audit_status == 0) row.mini_info.option_status = 4;
        _this6.$message({
          message: '刷新状态成功',
          type: 'success'
        });
      });
    },
    /**
     * 发布代码
     */
    releaseCode: function releaseCode(row) {
      var _this7 = this;
      this.$post('WxOpen/releaseMiniCode', {
        wxmini_appid: row.app_id
      }).then(function (res) {
        row.mini_info.option_status = 6;
        _this7.$message({
          message: '发布成功',
          type: 'success'
        });
      });
    }
  }
};